<template>
  <v-btn
    class="add-fab"
    icon
    :aria-label="ariaLabel"
    @click="$emit('click')"
  >
    <v-icon icon="mdi-plus" size="28" color="white" />
  </v-btn>
</template>

<script setup>
defineProps({
  /** Lo pone quien lo usa, ya traducido. */
  ariaLabel: {
    type: String,
    default: ''
  }
})

defineEmits(['click'])
</script>

<style scoped>
.add-fab {
  position: fixed !important;
  /* El footer ya no es fijo: el botón puede bajar hasta la esquina. */
  bottom: var(--ws-space-6);
  right: var(--ws-space-6);
  z-index: 1000;
  width: 64px !important;
  height: 64px !important;
  min-width: 64px !important;
  min-height: 64px !important;
  border-radius: 50% !important;
  background: linear-gradient(135deg, var(--ws-brand-purple-700) 0%, var(--ws-type-serie-from) 100%) !important;
  box-shadow: var(--ws-shadow-brand), var(--ws-shadow-lg) !important;
  transition: transform var(--ws-duration) var(--ws-ease), box-shadow var(--ws-duration) var(--ws-ease) !important;
}

@media (max-width: 600px) {
  .add-fab {
    bottom: var(--ws-space-4);
    right: var(--ws-space-4);
    width: 56px !important;
    height: 56px !important;
    min-width: 56px !important;
    min-height: 56px !important;
  }
}

.add-fab:hover {
  transform: scale(1.05) rotate(45deg);
  box-shadow: 0 6px 18px rgba(110, 17, 176, 0.5), 0 8px 24px rgba(0, 0, 0, 0.3) !important;
}

.add-fab:deep(.v-icon) {
  color: white !important;
}
</style>
